import { PropsWithChildren } from 'react';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';

import { Badge } from './ui/Badge';

export const MaintenanceMode = ({ children }: PropsWithChildren) => {
  const { isFeatureEnabled: isMaintenanceModeEnabled } =
    useFeatureFlag('maintenance-mode');

  if (isMaintenanceModeEnabled) {
    return (
      <div className="grid place-items-center h-screen z-[1000]">
        <div className="flex flex-col items-center gap-y-4">
          <img
            src="/images/Praxis-by-Emergn-black.svg"
            alt="Praxis by Emergn"
            className="h-12 dark:hidden"
          />
          <img
            src="/images/Praxis-by-Emergn-white.svg"
            alt="Praxis by Emergn"
            className="h-12 hidden dark:block"
          />
          <Badge
            variant="outline"
            className="uppercase gap-1 shadow-lg"
            role="status"
          >
            <span className="relative flex size-3 align-middle">
              <span className="absolute inset-0 m-auto size-2 animate-ping rounded-full bg-orange-500 opacity-50"></span>
              <span className="absolute inset-0 m-auto size-1.5 rounded-full bg-orange-500 opacity-75"></span>
            </span>
            <h1>scheduled maintenance</h1>
          </Badge>

          <p className="text-center">
            We are busy updating our platform. This scheduled{' '}
            <br className="hidden md:block" />
            maintenance shouldn't take longer than 4 hours.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
